<template>
  <!-- Navbar -->
  <nav class="top-0 navbar navbar-expand-lg position-absolute z-index-3 start-0 end-0"
    style="background-color: #24252a;">
    <div class="container" style="max-width: 3000px;">
      <router-link to="/home" :class="darkMode ? 'text-black' : 'text-white'">
        <img :src="logoSecond" style="max-width: 200px; max-height: 70px;" />
      </router-link>
      <div id="navigation" class="pt-3 pb-2 collapse navbar-collapse w-100 py-lg-0">
        <ul class="mx-auto navbar-nav navbar-nav-hover">
          <li v-for="menu in menus" :key="menu.menuName"
            class="mx-2 cursor-pointer nav-item nav-menu text-center dropdown dropdown-hover border-radius-md"
            style="height: 40px;" @click="menu.list == null ? generateHrefpolicy(menu.href) : null">
            <a id="dropdownMenuPages"
              class="text-white nav-link text-lg d-flex justify-content-between align-items-center"
              :class="getRoute()[1] === menu.path ? 'bg-success' : ''" role="button"
              style="border-radius: 50px; padding-right: 30px; padding-left: 30px;" aria-expanded="false">
              {{ menu.menuName }}
            </a>
            <div v-if="menu.list != null" style="margin-top: 21px !important"
              class="p-3 mt-0 dropdown-menu dropdown-menu-animation dropdown-md dropdown-md-responsive border-radius-lg"
              aria-labelledby="dropdownMenuBlocks">
              <div class="d-none d-lg-block">
                <ul class="list-group">
                  <li v-for="list in menu.list" :key="list.itemName"
                    class="p-0 border-0 nav-item dropdown dropdown-hover dropdown-subitem list-group-item"
                    @click="generateHrefpolicy(list.href)">
                    <div :class="'/' + getRoute()[1] + '/' + getRoute()[2] === list.href ? 'bg-info' : ''"
                      class="py-2 dropdown-item ps-3 border-radius-md">
                      <div class="d-flex">
                        <div class="w-100 d-flex align-items-center justify-content-between">
                          <p :class="'/' + getRoute()[1] + '/' + getRoute()[2] === list.href ? 'text-white' : 'text-dark'"
                            class="p-0 text-lg dropdown-header">
                            {{ list.itemName }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="dropdown">
        <div id="navbarDropdownMenuLink2" class="profile-card dropdown-toggle" data-bs-toggle="dropdown">
          <div class="profile-image">
            <img :src="user" alt="Profile Picture">
          </div>
          <div class="profile-info">
            <p class="name">{{ fullName }}</p>
            <p class="email">{{ userEmail }}</p>
          </div>
        </div>
        <ul class="dropdown-menu" style="margin-top: 30px !important;" aria-labelledby="navbarDropdownMenuLink2">
          <li @click="SignOut">
            <a class="dropdown-item text-lg" style="font-size: 18px !important; min-width: 15rem" href="javascript:;">
              <i class="fa fa-sign-out-alt" aria-hidden="true"></i> &nbsp; Etibarlı çıxış
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import logoSecond from "@/assets/img/logos/progressico2white.png";
import user from "@/assets/img/logos/user.png";

const menus = [
  { menuName: 'Ana səhifə', path: 'home', href: '/home', list: null },
  { menuName: 'Yeni işlər', path: 'dashboard', href: '/dashboard', list: null },
  { menuName: 'Subroqasiya', path: 'subrogation', href: '/subrogation/list', list: null },
  {
    menuName: 'Jurnallar', path: 'journal', href: '/journal', list: [
      { itemName: 'Təqvim', href: '/journal/calendar' },
      { itemName: 'Xəbərdarlıqlar', href: '/journal/warnings' },
      { itemName: 'Debitor borclar', href: '/journal/debtors' },
    ]
  },
  { menuName: 'Hesabat', path: 'dashboard5', href: '/dashboard', list: null },
];

export default {
  name: "Navbar",
  props: {
    darkMode: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      menus,
      logoSecond,
      user,
    };
  },
  computed: {
    fullName() {
      return this.$store.state.user && this.$store.state.user.name
        ? this.$store.state.user.name
        : "İstifadəçi adı";
    },
    userEmail() {
      return this.$store.state.user && this.$store.state.user.email
        ? this.$store.state.user.email
        : "";
    }
  },
  methods: {
    getRoute() {
      return this.$route.path.split("/");
    },
    generateHrefpolicy(href) {
      window.location.href = href;
    },
    SignOut() {
      this.$router.push('/session/LOGOUT');
    }
  }
};
</script>

<style scoped>
.nav-menu {
  position: relative;
}

.nav-menu::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: #4db2e5;
  transition: width 0.3s ease, left 0.3s ease;
  transform: translate(-50%, -100%);
}

.nav-menu:hover::before {
  width: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
}

.profile-card {
  display: flex;
  align-items: center;
  border-radius: 10px;
}

.profile-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
}

.profile-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-info {
  flex-grow: 1;
}

.profile-info .name {
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  color: white;
}

.profile-info .email {
  font-size: 15px;
  margin: 0;
  color: #4db2e5;
}
</style>
